import { PURCHASE_MOTIONS } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import { setCustomerCurrencyCode } from './CurrencyCodeActions';
import FallbackPublicPurchaseMotions from 'pricing-pages-lib/constants/FallbackPublicPurchaseMotions';
export const FetchPurchaseMotionRequestTypes = createRequestTypes(PURCHASE_MOTIONS);
export const FetchPurchaseMotionActions = createRequestActions(FetchPurchaseMotionRequestTypes);
export const fetchPurchaseMotionData = ({
  getPurchaseMotions,
  isPublic = false
}) => dispatch => {
  dispatch(FetchPurchaseMotionActions.request());
  return getPurchaseMotions().then(data => {
    const {
      customerCurrencyCode,
      locations
    } = data;

    if (!isPublic) {
      dispatch(setCustomerCurrencyCode(customerCurrencyCode));
    }

    dispatch(FetchPurchaseMotionActions.receive(locations));
  }).catch(error => {
    if (isPublic) {
      dispatch(FetchPurchaseMotionActions.receive(FallbackPublicPurchaseMotions));
    } else {
      dispatch(FetchPurchaseMotionActions.failure(error));
      throw error;
    }
  });
};